import type { DeleteTagTypesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (
  affectedRows: number
): DeleteTagTypesMutation => {
  return {
    deleteTagTypeApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: affectedRows,
    },
  };
};

export const useDeleteTagTypesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.tag.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.tag.pathKey(),
        });
      },
    }),
  });

  return {
    deleteTagTypes: async (variables: {
      Ids: string[];
    }): Promise<DeleteTagTypesMutation> => {
      const result = await mutation.mutateAsync({ Ids: variables.Ids });

      return mapTrpcResponseToGraphQL(result.affected_rows);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
